import * as React from 'react'
import ReadService from "../../service/read";
import Wait from "../wait";

export default class VLUMPRAListPane extends React.Component {

    static self

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none'
        }
        VLUMPRAListPane.self = this
    }

    componentDidMount() {
        VLUMPRAListPane.loadData()
    }


    render() {

        return (<div className={'row'}>
            <div className={'col col-sm-12'} style={{padding:0}}>
                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Registered Users
                    </span>



                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <div style={{height: '60vh'}}>

                    <button style={{float: 'right', margin: '16px 4%'}} className={'btn submit'}>
                        <span className={'fa fa-plus'}/>Add New
                    </button>

                    <table className={'tb'} style={{width:'94%',margin:'2%'}}>
                        <thead>
                        <tr>
                            <th style={{width:'50px'}}>#.</th>
                            <th>Full Name</th>
                            <th>Village</th>
                            <th>Profession</th>
                            <th>Role</th>
                            <th>Is Active</th>
                            <th style={{display:this.state.show_actions,textAlign:'right'}}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} title={d.description}>
                                <td>
                                    <div style={{width:'14px',float:'left'}}>
                                        {i+1}.
                                    </div>
                                    <input type={'checkbox'} style={{marginLeft:'8px'}}/>
                                </td>
                                <td>
                                    <b style={{color:'darkcyan'}}>{d.fullname}</b>
                                </td>
                                <td>{d.office}</td>
                                <td>{d.profession}</td>
                                <td>{d.role}</td>
                                <td>{d.is_active}</td>
                                <td style={{display:this.state.show_actions,textAlign:'right'}}>
                                    <button className={'ubtn-info'}>
                                        <span className={'fa fa-edit'} style={{marginRight:0}}/>
                                    </button>
                                    <button className={'ubtn-info'}>
                                        <span className={'fa fa-trash'} style={{marginRight:0}}/>
                                    </button>
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                </div>

            </div>


        </div>)
    }


    static loadData() {
        try {
            Wait.show('Fetching Users....')
            ReadService.fetchUsers().then(r=>{
                Wait.dismiss()
                /*UserListPane.self.setState({
                    data:r.data.results
                })*/
            })
        }catch (e) {

        }
    }
}
